import { render, staticRenderFns } from "./YouTubeReplyComment.vue?vue&type=template&id=7188d80a&scoped=true"
import script from "./YouTubeReplyComment.vue?vue&type=script&lang=js"
export * from "./YouTubeReplyComment.vue?vue&type=script&lang=js"
import style0 from "./YouTubeReplyComment.vue?vue&type=style&index=0&id=7188d80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7188d80a",
  null
  
)

export default component.exports